import { AGENT_PROFILE_IMG } from "helpers/sf_constants"
import {
  GET_AGENT_PROFILE,
  GET_AGENT_PROFILE_SUCCESS,
  GET_AGENT_PROFILE_ERROR,
  MODIFY_AGENT_PROFILE,
  MODIFY_AGENT_PROFILE_SUCCESS,
  MODIFY_AGENT_PROFILE_ERROR,
  UPLOAD_AGENT_PROFILE_IMAGES,
  GET_QUOTE_FUNNELS,
  GET_QUOTE_FUNNELS_SUCCESS,
  GET_QUOTE_FUNNELS_ERROR,
  MODIFY_QUOTE_FUNNEL,
  MODIFY_QUOTE_FUNNEL_ERROR,
  MODIFY_QUOTE_FUNNEL_SUCCESS,
  CREATE_DEFAULT_QUOTE_FUNNELS,
  CREATE_DEFAULT_QUOTE_FUNNELS_SUCCESS,
  UPLOAD_AGENT_PROFILE_IMAGES_SUCCESS,
  UPLOAD_AGENT_PROFILE_IMAGES_ERROR,
  GET_AGENT_PROFILE_POPUP_MESSAGE,
  GET_AGENT_PROFILE_POPUP_MESSAGE_SUCCESS,
  GET_AGENT_PROFILE_POPUP_MESSAGE_ERROR
} from "./actionTypes"

const initialState = {
  agent_profile: {},
  agent_profile_loading: false,
  agent_profile_update_loading: false,
  agent_profile_error: null,
  agent_profile_avatar_images_upload_loading: false,
  agent_profile_logo_images_upload_loading: false,
  quote_funnels: null,
  quote_funnel_loading: false,
  quote_funnel_error: null,
  agent_profile_popup_message: [],
  agent_profile_popup_message_loading: false,
  agent_profile_popup_message_error: null
}

const QuoteFunnelRedcuer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AGENT_PROFILE:
      return {
        ...state,
        agent_profile_loading: true,
      }
    case GET_AGENT_PROFILE_SUCCESS:
      return {
        ...state,
        agent_profile_loading: false,
        agent_profile: action.payload,
        agent_profile_error: null
      }
    case GET_AGENT_PROFILE_ERROR:
      return {
        ...state,
        agent_profile_loading: false,
        agent_profile_error: action.payload
      }

    case GET_AGENT_PROFILE_POPUP_MESSAGE:
      return {
        ...state,
        agent_profile_popup_message_loading: true
      }

    case GET_AGENT_PROFILE_POPUP_MESSAGE_SUCCESS:
      return {
        ...state,
        agent_profile_popup_message: action.payload,
        agent_profile_popup_message_loading: false,
        agent_profile_popup_message_error: null
      }

    case GET_AGENT_PROFILE_POPUP_MESSAGE_ERROR:
      return {
        ...state,
        agent_profile_popup_message_error: action.payload,
        agent_profile_popup_message_loading: false
      }

    case MODIFY_AGENT_PROFILE:
      return {
        ...state,
        agent_profile_update_loading: true
      }
    case MODIFY_AGENT_PROFILE_SUCCESS:
      return {
        ...state,
        agent_profile: action.payload,
        agent_profile_error: null,
        agent_profile_update_loading: false
      }
    case MODIFY_AGENT_PROFILE_ERROR:
      return {
        ...state,
        agent_profile_error: action.payload,
        agent_profile_update_loading: false
      }
    case UPLOAD_AGENT_PROFILE_IMAGES:
      return {
        ...state,
        agent_profile_avatar_images_upload_loading: action?.payload?.upload_image_type === AGENT_PROFILE_IMG.PROFILE_IMG ? true : state.agent_profile_avatar_images_upload_loading,
        agent_profile_logo_images_upload_loading: action?.payload?.upload_image_type === AGENT_PROFILE_IMG.COMPANY_LOGO_IMG ? true : state.agent_profile_logo_images_upload_loading,
      }
    case UPLOAD_AGENT_PROFILE_IMAGES_SUCCESS:
      return {
        ...state,
        agent_profile_avatar_images_upload_loading: action?.payload?.upload_image_type === AGENT_PROFILE_IMG.PROFILE_IMG ? false : state.agent_profile_avatar_images_upload_loading,
        agent_profile_logo_images_upload_loading: action?.payload?.upload_image_type === AGENT_PROFILE_IMG.COMPANY_LOGO_IMG ? false : state.agent_profile_logo_images_upload_loading,
        agent_profile: action.payload.agent_profile,
      }
    case UPLOAD_AGENT_PROFILE_IMAGES_ERROR:
      return {
        ...state,
        agent_profile_avatar_images_upload_loading: false,
        agent_profile_logo_images_upload_loading: false,
        agent_profile_error: action.payload,
      }
    case GET_QUOTE_FUNNELS:
      return {
        ...state,
        quote_funnel_loading: true
      }
    case GET_QUOTE_FUNNELS_SUCCESS:
      return {
        ...state,
        quote_funnel_loading: false,
        quote_funnels: action.payload
      }
    case GET_QUOTE_FUNNELS_ERROR:
      return {
        ...state,
        quote_funnel_loading: false,
        quote_funnel_error: action.payload
      }
    case MODIFY_QUOTE_FUNNEL:
      return {
        ...state,
        quote_funnel_loading: true
      }
    case MODIFY_QUOTE_FUNNEL_SUCCESS:
      return {
        ...state,
        quote_funnel_loading: false,
        quote_funnels: state.quote_funnels.map((quote_funnel) => (quote_funnel.id === action.payload.id) ?
          action.payload : quote_funnel),
        agent_profile_error: null
      }
    case MODIFY_QUOTE_FUNNEL_ERROR:
      return {
        ...state,
        quote_funnel_loading: false,
        quote_funnel_error: action.payload
      }
    case CREATE_DEFAULT_QUOTE_FUNNELS:
      return {
        ...state,
        quote_funnel_loading: true
      }
    case CREATE_DEFAULT_QUOTE_FUNNELS_SUCCESS:
      return {
        ...state,
        quote_funnel_loading: false,
        quote_funnels: [...state.quote_funnels, ...action.payload]
      }
    default:
      return state
  }
}

export default QuoteFunnelRedcuer